import { Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';

@Component({
  selector: 'app-baner-publicity',
  imports: [],
  templateUrl: './baner-publicity.component.html',
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class BanerPublicityComponent {

}
